var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a8a29e",
    d: "M 62.976562 69.273438 L 5.726562 69.273438 L 5.726562 12.023438 L 40.078125 12.023438 L 40.078125 6.296875 L 5.726562 6.296875 C 2.566406 6.296875 0 8.863281 0 12.023438 L 0 69.273438 C 0 72.433594 2.566406 75 5.726562 75 L 62.976562 75 C 66.136719 75 68.703125 72.433594 68.703125 69.273438 L 68.703125 34.921875 L 62.976562 34.921875 Z M 62.976562 69.273438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a8a29e",
    d: "M 22.902344 52.191406 L 34.953125 52.191406 L 64.164062 22.980469 L 52.019531 10.835938 L 22.902344 39.957031 Z M 22.902344 52.191406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a8a29e",
    d: "M 72.75 6.296875 L 68.703125 2.25 C 66.464844 0.0117188 62.839844 0.0117188 60.605469 2.25 L 56.066406 6.789062 L 68.210938 18.933594 L 72.75 14.394531 C 74.988281 12.15625 74.988281 8.53125 72.75 6.296875 Z M 72.75 6.296875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cca82b356682b61fda31faa975424b8b.svg";
export { ForwardRef as ReactComponent };